import { useCallback, useContext, useEffect, useMemo, useState } from 'react'
import { DomainContext } from '@/context/DomainContext'
import { IsListNotEmpty } from '@/utils'
import { useGet } from '@/api/hooks'
import { Localizer } from '@/utils/langUtils'
import i18n from '@/langsconfig/i18n'


export const useDropDownData = (ApiMethod, optionList = [], sourceId, key, isMulti, selectFirst, defaultValue) => {

    const { customSearchData, setCustomSearchData, clearField } = useContext(DomainContext)

    const { result } = useGet({
        endPoint: ApiMethod,
        AllowFetch: !!customSearchData[sourceId] && IsListNotEmpty(optionList),
        params: [customSearchData[sourceId]],
        depArr: [customSearchData[sourceId], sourceId],
        defaultValue: []
    })

    const options = useMemo(() => {
        return Localizer(optionList) || result
    }, [result, optionList, i18n.language])

    const [sOptions, setSOptions] = useState(defaultValue || null);

    useEffect(() => {

        let value = !isMulti ? null : []

        if (!selectFirst) return handleSOption(value || defaultValue)

        let firstVal = options[0]
        value = isMulti ? firstVal || defaultValue : [firstVal || defaultValue]

        if (selectFirst) return handleSOption(value)

    }, [options, clearField])



    const handleSOption = useCallback((sOption) => {
        setSOptions(sOption);
        setCustomSearchData((prev) => {
            const updated = { ...prev };
            if (!isMulti) {
                if (sOption) {
                    updated[key] = sOption?.value;
                } else {
                    delete updated[key];
                }
            } else {
                const values = (sOption || []).map(o => o?.value).filter(v => v !== undefined && v !== null);
                if (values.length > 0) {
                    updated[`${key}s`] = values;
                } else {
                    delete updated[`${key}s`];
                }
            }
            return updated;
        });
    }, [isMulti, key, customSearchData]);

    return { options, sOptions, handleSOption }
}
